import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./StandardContentDropdownList.module.css";
import FeedItemOptionsDropdown from "../FeedItemOptionsDropdown";
import StandardContentCardInfoDropdown from "../StandardContentCardInfoDropdown";
import FeedItemContentsDropdown from "../FeedItemContentsDropdown";
import { isEqual } from "lodash-es";

/**
 * A list of dropdowns with a Standard Content feed item’s properties.
 * Only one dropdown may be open at a given time.
 */

export function StandardContentDropdownList({ feedItem, setFeedItem, isNew }) {
  // Decides what dropdown is open contents, info, options
  const [dropdownOpen, setDropdownOpen] = useState("close");

  const [sections, setSections] = useState(
    feedItem?.content?.sections ||
      feedItem?.information?.content?.sections ||
      []
  );

  useEffect(() => {
    // const currentSections = feedItem?.content?.sections || [];
    // if (!isEqual(currentSections, sections)) {
    //   console.log(Date.now());
    // console.log(sections, feedItem)
    setFeedItem((prev) => ({
      ...prev,
      content: {
        ...prev.content,
        sections: sections,
      },
    }));
    // }
  }, [sections]);

  const setIsOpen = (dropdown) => {
    setDropdownOpen(dropdown);
  };

  // Feed Item Options Dropdown
  const [sendUpdate, setSendUpdate] = useState(true);
  const handleSendUpdate = () => {
    setSendUpdate(!sendUpdate);
  };

  return (
    <>
      {["close", "options"].includes(dropdownOpen) && (
        <FeedItemOptionsDropdown
          isOpen={dropdownOpen === "options"}
          onClick={setIsOpen}
          optionsConfig={{
            ...feedItem?.options,
          }}
          setOptionsConfig={(newOptions) => {
            setFeedItem((prev) => ({
              ...prev,
              options: {
                ...prev.options,
                ...newOptions,
              },
            }));
          }}
          isEdit={isNew}
          sendUpdate={sendUpdate}
          setSendUpdate={handleSendUpdate}
        />
      )}

      {(dropdownOpen === "close" || dropdownOpen === "info") && (
        <StandardContentCardInfoDropdown
          isOpen={dropdownOpen === "info"}
          onClick={setIsOpen}
          cardInformation={feedItem?.information || {}}
          setCardInformation={(newInfo) => {
            setFeedItem((prev) => ({
              ...prev,
              // Update top-level imgSrc even when cleared to ""
              imgSrc: Object.prototype.hasOwnProperty.call(newInfo, "imgSrc")
                ? newInfo.imgSrc
                : prev.imgSrc,
              information: {
                ...prev.information,
                ...newInfo,
              },
            }));
          }}
        />
      )}

      {(dropdownOpen === "close" || dropdownOpen === "contents") && (
        <FeedItemContentsDropdown
          sections={sections}
          setSections={setSections}
          isSectionOpen={dropdownOpen === "contents"}
          onClick={setIsOpen}
        />
      )}
    </>
  );
}

StandardContentDropdownList.propTypes = {
  /**
   * Object that contains all of a Standard Content feed item’s properties.
   */
  feedItem: PropTypes.object,

  /**
   * Function that sets the value of the feedItem prop.
   */
  setFeedItem: PropTypes.func,
};
